<template>

  <div>
    <div class="form-group">
      <label class="custom-label">{{labelDesc}}</label>
      <button v-show="config.isHeight" class="btn float-right" @click="showConfig"><i class="fa fa-cogs"></i></button>
    </div>
    <div v-if="!userConfig">
    <div class="form-group" v-show="!canBeCheckbox || !valueChecked">
      <div>
        <label class="label-range-custom">
          <input type="range" class="custom-range" :min="min" :max="max" step="1" v-model="value" @change="changeValue">
          <input type="number" class="custom-input form-control " v-model="value" :min="min" :max="max" step="1"
              @change="changeValue" 
              @focusout="changeValue">
        </label>
      </div>

    </div>
    <div class="form-group" v-show="canBeCheckbox">
      <div class="form">
        <label>
          <input type="checkbox" v-model="valueChecked" @change="changeValue"
                 @keyup="changeValue">
          {{labelCheckbox}}
        </label>
      </div>
    </div>
    </div>
    <div v-else>
      <div class="row" style="padding: 25px">
        <div class="form-group col-8">
          <label for="">Max height</label>
          <input class="form-control" type="number" v-model="config.maxHeight">
        </div>
        <div class="form-group col-4">
          <label for="">Save</label>
          <button class="btn btn-primary" @click="setMaxHeight"><i class="fa fa-save"></i></button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>

  export default {
    name: 'SliderInputComponent',
    data() {
      return {
        element: null,
        value: 50,
        valueChecked: false,
        canBeCheckbox: false,
        labelCheckbox: '',
        labelDesc: 'opa',
        callback: null,
        userConfig: false,
        config: {
          maxHeight: 5000,
          isHeight: false,
        },
        min: 0,
        max: 100,
      }
    },
    methods: {
      showConfig() {
        this.userConfig = !this.userConfig;

         if(localStorage.getItem('user-max-height-elements') === null) {
            localStorage.setItem('user-max-height-elements', 5000);
        }

        this.config.maxHeight = parseInt(localStorage.getItem('user-max-height-elements'));
      },
      setMaxHeight() {
        this.userConfig = false;
        localStorage.setItem('user-max-height-elements', this.config.maxHeight);
        this.max = this.config.maxHeight;
      },
      changeValue() {
        if (this.value < this.min)
          this.value = this.min;

        if (this.value > this.max)
          this.value = this.max;


        this.callback(this.value);
      },
      setValues(obj) {
        this.value = parseInt(obj.defaultValue);
        this.valueChecked = obj.defaultValueChecked;

        this.canBeCheckbox = obj.canBeCheckbox;
        this.labelCheckbox = this.$t(obj.labelCheckbox);


        if(typeof obj.labelDesc !== 'undefined' && obj.labelDesc === 'height') {
          this.config.isHeight = true;
          if(localStorage.getItem('user-max-height-elements') === null) {
              localStorage.setItem('user-max-height-elements', 5000);
          }

          obj.max = localStorage.getItem('user-max-height-elements');
        }

        this.min = parseInt(obj.min);
        this.max = parseInt(obj.max);
        this.element = obj.element;
        this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
        this.callback = obj.callback;
      }
    }
  }

</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }

  .label-range-custom {
    display: inline-flex;
    width: 250px;
    margin-top: 10px;
  }

  .custom-range {
    width: 100%;
    margin-left: 10px;
    margin-right: 10px;
  }

  .custom-input {
    margin-top: -10px;
    width: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resource_components/Slider.vue